// @wavvest/shared-utils — Apex allocation helpers
//
// Central list of Apex "securities" that are really cash. These are automatic
// FDIC cash-sweep vehicles that appear in every account: Apex reports them as
// holdings with their own symbol, but for asset-allocation purposes they must
// be treated as Cash (not Equities). Keeping the list here means every portal
// classifies them identically and future sweep symbols only need to be added
// in one place.
//
//   - USD:   Apex cash balance symbol
//   - FQLPZ: Apex "FDIC SWEEP (RIA)" sweep vehicle
export const CASH_SWEEP_SYMBOLS = new Set<string>(["USD", "FQLPZ"]);

/**
 * True when the holding symbol is a known cash-sweep / cash-equivalent vehicle
 * that should be classified as Cash regardless of how Apex reports it.
 */
export const isCashSweepSymbol = (symbol?: string | null): boolean =>
  symbol != null && CASH_SWEEP_SYMBOLS.has(symbol);
